<template>
  <div class="shootHotspots" v-if="datas && currThemeObj">
    <span class="hotItem" :class="[dynamicOpts.webKey, dynamicOpts.webType]">
      <span class="themeItem_objectInfo">
        <template v-if="themetype === 'A' && teamInfors">
          <AbPlayerImg
            :playerImg="teamInfors.playerInfos[0].profilePicture"
            :playerNum="teamInfors.playerInfos[0].shirtNumber * 1"
            :playerName="`${teamInfors.playerInfos[0].playerName}  ${
              teamInfors.playerInfos[0].position
                ? '(' + teamInfors.playerInfos[0].position + ')'
                : ''
            }`"
            :countryImg="teamInfors.teamLogo"
            :countryName="teamInfors.teamName"
            :countryLogoSize="countryLogoSize"
          ></AbPlayerImg>
        </template>
        <template v-else-if="themetype === 'T' && teamInfors">
          <DelegationImg
            :countryImg="teamInfors.teamLogo"
            :countryName="teamInfors.teamName"
            :logoHeight="'7vw'"
            :width="'7vw'"
          ></DelegationImg>
        </template>
      </span>
      <span class="svgList_area">
        <span class="svgArea_header">
          <span class="svgArea_header_select">
            <!-- <SelectItem
              :key="svgSelectList[groupIndex].state"
              :options="svgSelectList[groupIndex]"
              :curVal="svgSelectList[groupIndex].curVal"
              themeClass="whiteBg"
              @changeValEvent="selectChangeVal"
            ></SelectItem> -->
            <slot name="selectItem"></slot>
          </span>
          <span class="svgArea_header_public">
            <!-- <span class="publishBtn" @click="clickPublicTheme(themeItem)">
              <svg
                t="1692698307306"
                class="publishBtn_icon"
                viewBox="0 0 1024 1024"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
                p-id="9670"
                width="68%"
                height="68%"
              >
                <path
                  d="M853.333333 533.333333a32 32 0 0 1 64 0v266.666667c0 64.8-52.533333 117.333333-117.333333 117.333333H224c-64.8 0-117.333333-52.533333-117.333333-117.333333V256c0-64.8 52.533333-117.333333 117.333333-117.333333h277.333333a32 32 0 0 1 0 64H224a53.333333 53.333333 0 0 0-53.333333 53.333333v544a53.333333 53.333333 0 0 0 53.333333 53.333333h576a53.333333 53.333333 0 0 0 53.333333-53.333333V533.333333z m-42.058666-277.333333l-89.792-95.402667a32 32 0 0 1 46.613333-43.861333l140.544 149.333333C927.861333 286.485333 913.376 320 885.333333 320H724.704C643.029333 320 576 391.210667 576 480v192a32 32 0 1 1-64 0V480c0-123.296 94.784-224 212.704-224h86.570667z"
                  p-id="9671"
                ></path>
              </svg>
            </span> -->
            <slot name="publishBtn"></slot>
          </span>
        </span>
        <span class="svgDataRow" v-for="item in svgDataList" :key="item.key">
          <span class="svgDataRow_svg" v-if="cy">
            <cup_svgSingleCircle
              :currThemeObj="currThemeObj"
              :teamMode="dynamicOpts.webKey"
              :cx="cx"
              :cy="cy"
              :strokeWidth="strokeWidth"
              :svgData="item"
              :keyArr="svgKeyArr"
              :svgCenterInforArr="svgCenterInforArr"
              :svgCenterInforTextFontSizeArr="svgCenterInforTextFontSizeArr"
            ></cup_svgSingleCircle>
          </span>
          <span class="svgDataRow_data">
            <span
              class="svgData_annotate_row"
              v-for="(name, rowIndex) in item.nameArr"
              :key="rowIndex"
            >
              <span class="svgData_annotate_row_clo1" v-text="name"></span>
              <span class="svgData_annotate_row_clo2">
                <NumberScrolling
                  :tarVal="item.valArr[rowIndex]"
                  :unit="''"
                ></NumberScrolling>
              </span>
            </span>
          </span>
        </span>
      </span>
      <span class="hotArea" :class="isShowTip ? '' : 'notTip'">
        <HalfFeildShootHotspot
          v-if="hotSpotList"
          :datas="hotSpotList"
          :iconArr="echartsHotSpotIconArr"
        ></HalfFeildShootHotspot>
        <span class="themeTips">
          <span
            class="themeTipsItem"
            v-for="(icon, iconIndex) in echartsHotSpotIconArr"
            :key="iconIndex"
          >
            <span class="themeTipsItem_icon">
              <img :src="icon.split('image://')[1]" />
            </span>
            <span
              class="themeTipsItem_text"
              v-text="echartsIconTipArr[iconIndex]"
            ></span>
          </span>
        </span>
      </span>
    </span>
  </div>
</template>

<script>
// 单人 || 单只球队 投篮热区
import cup_base_data_mixin from '@mixins/cup_base_data'
import AbPlayerImg from '@components/compreSportsMeet/html/components/PlayerImg.vue'
import DelegationImg from '@components/compreSportsMeet/html/components/DelegationImg.vue'
import cup_svgSingleCircle from '@components/platfromBase/football/cup_svgSingleCircle.vue'
import HalfFeildShootHotspot from '@components/basketball/echarts/scatter/halfFeild_shootHotspot.vue'
import NumberScrolling from '@components/compreSportsMeet/html/components/NumberScrolling'
export default {
  name: 'basketball_league_shootHotspots',
  mixins: [cup_base_data_mixin],
  components: {
    AbPlayerImg,
    DelegationImg,
    cup_svgSingleCircle,
    HalfFeildShootHotspot,
    NumberScrolling,
  },
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        webKey: '',
        webType: '',
        objectInfo: [],
        data: {
          shotPoints: [],
        },
        statisticsModels: [],
      }),
    },
    isShowTip: {
      type: Boolean,
      default: false,
    },
    baseOpts: {
      type: Object,
      default: () => ({
        svgKeyArr: ['name', 'val'], // 数据中需要的映射的字段名['name', 'val']
        svgCenterInforArr: ['val', 'name'], // 中间显示的内容；['name', 'val']
        strokeWidthVw: 0.278, //描边宽度
        cxVw: 3.6, //圆点 x坐标
        cyVw: 3.6, //圆点 y坐标
        echartsIconTipArr: ['投篮命中', '投篮未命中'],
        // echartsHotSpotIconArr: [
        //   'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAa5JREFUSEu9lj1LJEEQhp9qBUX8iJXdVVBE7n7AGR+XiKCYm4gfiSIYiZuIyewZHYgmp4eJuSioiRjrD7hDRcEvNNYVUXC7ZAbG093eZUXbCqeK96muqq4eoYS1zWriQelVpRtoRWmKwoVL4FiEjSph7WhSLorJiMuRnNUmscxYGECpKJUEQs7AshqmzyclBL+yAkAy0B4VVlDqSgoXKmVF6T9Py/pL1ytAKtBxC78A8ybx/8HWwMRZWubiT8+AKHNYfYd4rGkF+uKTRICw5mrZf3NZinc2K4aOsCcRIJXRRasMOeMFRVmqhD81DfwNY+6u+foIgwhDKM5BMcLS2ZQMSziK95YT17QIXBmh/3RKdlzw5ox+t8qKQmOBX8hVG1ok+VNH1TLvCNAK+FFMPI4PITnYdp1EDGOSyOgmSpcjw8WLtIyUM02JQH8Dw44kt0LAAUp7vrMSOk/SslcOoCXQb4+w6wAcSiLQLFCb76xvoO7fqNyWA/iyoLU314Q6+Xb7CQDvJfLdZO9j6v2ieV8Vn7LsIojPdR3fDq8PTgzx+mQ+Q3w++i+XyUf8tjwBnuwGpPR363YAAAAASUVORK5CYII=',
        //   'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAjFJREFUSEu9lj9oE3EUx7/fi71aSLvpUJJTTBBJxSmhg4t0EKRFcXeRti6K2FVBo6BrRZxsi4u7KK2CoLg4lGYSE1RyRS/FwW5NoDY1vye/Sy+5y52Bgudvu9/7vfd57/t+f47oMzay46nmTuuCCCcBZAQyqpcT/AHAJmXFHEy8SFVXN/4WhlEGJ316tMnmXSpcFkiiXxIEW2LgqSnmHav2QYMDIwRYT+fPK+EzQIb7BQ7bWDcol47VSi/9tgCgahWuU8m8AMb+grdXE1BicC7rrD3y/DsAnbkInoeCk2VSFg8g8WYoOeRox+3GtvUbrbMinIHIWE/GisRFrxIX4Gouzc89sggEDzKzU7dZLKqoiqRYNOyF5XsgbrYL6ORdN2me0D1xJ6tWYQFKZnxBZM9hE8REtlb6FAWopvMnIXgH4BAAz6e91OBi1lmbpd6KO7/Ut8BuEdwHcWXPMRLSE3wTgicgbnW1Z2vwoHGU6+n8VSV43K2O5cz05Cl7aTnnyy4ACQUnJjLTUxV7aeWjvycGcY12qvBKIOc6ZANzGaf00JUuKIELcdd1ZQmAbSt/QxTmfVW81oAvAjnuTQ4YibEjzmrF+w5B2gateUi679Z4ble1yj7AV1ZT+TqApDc5MpIcPlx53/A3tQeiTZF9+Zk7k9zaauh43mjED4hdov02mTJAwe7bqD5ENjn2bRr7QYv9qvgvl52GxHpdd05tnA+OB4n1yfQgsT76/jvoX/y2/AEx4rQmIjAhTQAAAABJRU5ErkJggg==',
        // ],
      }),
    },
    dynamicOpts: {
      type: Object,
      default: () => ({
        webKey: 'home',
        webType: '',
      }),
    },
  },
  data() {
    return {
      bodyWidth: 0,
      themetype: 'T',
      svgDataList: null,
      hotSpotList: null,
      teamInfors: null,
    }
  },
  watch: {
    datas(newVal, oldVal) {
      console.debug('newVal:', newVal)
      if (newVal && JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
        this.formatDatasHandler(newVal)
      }
    },
    immediate: false,
    deep: true,
  },
  created() {
    this.bodyWidth = window.innerWidth
      ? window.innerWidth
      : window.screen.width
      ? window.screen.width
      : 375

    this.svgKeyArr = this.baseOpts.svgKeyArr
    this.svgCenterInforArr = this.baseOpts.svgCenterInforArr
    this.strokeWidthVw = this.baseOpts.strokeWidthVw
    this.cxVw = this.baseOpts.cxVw
    this.cyVw = this.baseOpts.cyVw
    this.echartsIconTipArr = this.baseOpts.echartsIconTipArr
    this.echartsHotSpotIconArr = this.baseOpts.echartsHotSpotIconArr

    this.formatDatasHandler(this.datas)
  },
  computed: {
    strokeWidth() {
      return Math.ceil((this.bodyWidth / 100) * this.strokeWidthVw)
    },
    cx() {
      return Math.ceil((this.bodyWidth / 100) * this.cxVw)
    },
    cy() {
      return Math.ceil((this.bodyWidth / 100) * this.cyVw)
    },
    svgCenterInforTextFontSizeArr() {
      let arr = null
      if (this.dynamicOpts.webType === 'themeItem') {
        arr = ['0.974vw', '0.833vw', '1.805vw']
      } else {
        arr = ['1.11vw', '0.974vw', '1.805vw']
      }
      return arr
    },
    countryLogoSize() {
      if (
        this.datas &&
        this.datas.sportType === 'basketball' &&
        this.datas.competitionType === 'league'
      ) {
        return ['1.666vw', '1.666vw']
      } else {
        return ['2.498vw', '1.666vw']
      }
    },
  },
  methods: {
    _formatSpotDataHandler(arr) {
      //实际坐标x,y轴最大值 [49, 45.71] = [1, 1] 图表里面的x,y轴最大值
      // 以下是实际坐标对应图表中的各个点的位置
      // [-24.5, -5.56] = [0, 0] 左上角
      // [0,0] = [0.5,0.5] 中间
      // [24.5, 40.16] = [1, 1] 右下角

      const reality_x = 49,
        reality_y = 45.71
      const ceilRateNum_x = 100 / reality_x,
        ceilRateNum_y = 100 / reality_y
      return {
        pointX: Math.round(ceilRateNum_x * (arr[0] + 24.5) * 10) / 1000,
        pointY: Math.round(ceilRateNum_y * (arr[1] + 5.56) * 10) / 1000,
      }
    },
    formatDatasHandler(datas) {
      console.debug(datas)
      if (!datas) return
      let svgDataList = [],
        hotSpotList = null,
        themetype = ''
      const teamInfors = datas.objectInfo[0]
      const svgDataKey = [
        {
          propsArr: ['fieldGoalsMade', 'fieldGoalsAttempted', 'fieldGoalsPct'],
          valArr: [],
          nameArr: ['命中', '出手'],
          isFormatVal: '%', //是否过滤 fieldGoalsPct 中的值
          name: '投篮',
          val: 0,
          key: 'fieldGoalsPct',
          ceil: '%',
        },
        {
          propsArr: ['twoPointsMade', 'twoPointsAttempted', 'twoPointsPct'],
          valArr: [],
          nameArr: ['命中', '出手'],
          isFormatVal: '%',
          name: '两分球',
          val: 0,
          key: 'twoPointsPct',
          ceil: '%',
        },
        {
          propsArr: [
            'threePointsMade',
            'threePointsAttempted',
            'threePointsPct',
          ],
          valArr: [],
          nameArr: ['命中', '出手'],
          isFormatVal: '%',
          name: '三分球',
          val: 0,
          key: 'threePointsPct',
          ceil: '%',
        },
      ]

      svgDataList = svgDataKey.map((item) => {
        item.valArr = item.propsArr.map((ceil) => {
          return datas.data && datas.data[ceil] ? datas.data[ceil] : '0'
        })
        item.val = item.valArr[2]
          ? item.valArr[2].indexOf(item.isFormatVal) > -1
            ? item.valArr[2].split(item.isFormatVal)[0]
            : '0'
          : '0'
        return item
      })

      console.debug('svgDataList:', svgDataList)
      hotSpotList = {
        title: '',
        objectInfo: [],
        data: {
          dataList:
            datas.data && datas.data.shotPoints
              ? datas.data.shotPoints.map((item) => {
                  const { pointX, pointY } = this._formatSpotDataHandler([
                    item.shotCoordX,
                    item.shotCoordY,
                  ])
                  // console.debug('dataList:', pointX, pointY)
                  item.pointX = pointX
                  item.pointY = pointY
                  item.fgTypeStatus = item.eventType === 3
                  return item
                })
              : [],
        },
        statisticsModels: [],
      }

      if (
        teamInfors &&
        teamInfors.playerInfos &&
        teamInfors.playerInfos.length > 0
      ) {
        themetype = 'A'
      } else {
        themetype = 'T'
      }

      this.themetype = themetype
      this.teamInfors = teamInfors
      this.svgDataList = svgDataList
      this.hotSpotList = hotSpotList
    },
  },
}
</script>

<style lang="scss" scoped>
.shootHotspots {
  width: 100%;
  height: auto;
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  align-items: flex-start;
  .hotItem {
    width: calc(100% - 0.487vw);
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: flex-start;
    &.home {
      .hotArea {
        padding-left: 0.974vw;
      }
    }
    &.away {
      flex-direction: row-reverse;
      .hotArea {
        padding-right: 0.974vw;
      }
    }
    &.themeItem {
      width: 100%;
      padding: 0 0.347vw;
      justify-content: center;
      align-items: center;
      .themeItem_objectInfo {
        display: block;
        width: 8vw;
      }
      .svgList_area {
        width: 11.1vw;
        border: 0;
        .svgArea_header {
          display: none;
        }
        .svgDataRow {
          width: 100%;
          height: auto;
          display: flex;
          display: -webkit-flex;
          justify-content: space-between;
          align-items: center;
          padding: 0.3vw 0.5vw;
          .svgDataRow_svg {
            width: 50%;
          }
          .svgDataRow_data {
            width: 45%;
            .svgData_annotate_row {
              width: 100%;
              display: flex;
              display: -webkit-flex;
              justify-content: space-between;
              align-items: center;
              &:first-child {
                border-bottom: 1px solid var(--mixtmt_greyColor8);
              }
              .svgData_annotate_row_clo1,
              .svgData_annotate_row_clo2 {
                width: 50%;
                font-size: 0.833vw;
                line-height: 1.68vw;
                text-align: center;
              }
              .svgData_annotate_row_clo2 {
                padding-top: 0.3vw;
                font-size: 1.1vw;
                font-family: 'DINCondensed-Bold';
                font-weight: bold;
              }
            }
          }
        }
      }
      .hotArea {
        width: calc(100% - 20vw);
        .themeTips {
          padding-top: 0.974vw;
          .themeTipsItem {
            .themeTipsItem_icon {
              width: 1.11vw;
              height: 1.11vw;
            }
            .themeTipsItem_text {
              font-size: 0.833vw;
              line-height: 1.11vw;
            }
          }
        }
      }
    }

    .themeItem_objectInfo {
      display: none;
    }
    .svgList_area {
      width: 16.66vw;
      border: 1px solid var(--mixtmt_greyColor7);
      border-radius: 0.694vw;
      .svgArea_header {
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.347vw;
        border-bottom: 1px solid var(--mixtmt_greyColor7);
        .svgArea_header_select {
          width: 13.2vw;
        }
        .svgArea_header_public {
          width: calc(100% - 13.2vw);
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
        }
      }
      .svgDataRow {
        width: 100%;
        height: auto;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        padding: 0.694vw 0.974vw;
        .svgDataRow_svg {
          width: 50%;
        }
        .svgDataRow_data {
          width: 45%;
          .svgData_annotate_row {
            width: 100%;
            display: flex;
            display: -webkit-flex;
            justify-content: space-between;
            align-items: center;
            &:first-child {
              border-bottom: 1px solid var(--mixtmt_greyColor8);
            }
            .svgData_annotate_row_clo1,
            .svgData_annotate_row_clo2 {
              width: 50%;
              font-size: 0.974vw;
              line-height: 2.5vw;
              text-align: center;
            }
            .svgData_annotate_row_clo2 {
              padding-top: 0.3vw;
              font-size: 1.1vw;
              font-family: 'DINCondensed-Bold';
              font-weight: bold;
            }
          }
        }
      }
    }
    .hotArea {
      width: calc(100% - 16.66vw);
      height: auto;
      &.notTip {
        .themeTips {
          display: none;
        }
      }
      .themeTips {
        padding-top: 1.388vw;
        width: 100%;
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        .themeTipsItem {
          flex: 1;
          display: flex;
          display: -webkit-flex;
          justify-content: center;
          align-items: center;
          .themeTipsItem_icon {
            width: 1.388vw;
            height: 1.388vw;
            border-radius: 50%;
            img {
              display: block;
              width: 100%;
              height: 100%;
              object-fit: contain;
            }
          }
          .themeTipsItem_text {
            padding-left: 0.347vw;
            font-size: 0.974vw;
            line-height: 1.388vw;
          }
        }
      }
    }
  }
}
</style>
